import { Injectable } from '@angular/core';
import { ApiService } from 'app/core/services/apiservice';
import { ComentarioInterface, ComentariosResponseInterface } from 'app/models/comentarios-model';
import { BehaviorSubject } from 'rxjs';

@Injectable({providedIn: 'root'})
export class ComentariosService {

    _comentarios: BehaviorSubject<ComentarioInterface[]> = new BehaviorSubject([])
    constructor(private api: ApiService) {}

    //-----------  Properties -----------//

    get comentarios$() {
        return this._comentarios.asObservable()
    }


    //-----------  Methods -----------//

    getComentariosByEntity(entityUuid: string): Promise<ComentariosResponseInterface> {

        return new Promise((resolve, reject)=> {
            const url = `/comentarios/${entityUuid}`
            this.api.GetMethod(url, {}, 'Ocurrió un problema al obtener los comentarios de seguimeiento.')
                .subscribe((response: ComentariosResponseInterface) => {
                    this._comentarios.next(response.data)
                    resolve(response)
                })
        })
    }

    registrarComentario(entityUuid: string, comentario: string, notificar:boolean) {
        return new Promise((resolve, reject) => {
            const url = `/comentarios/${entityUuid}`
            const payload = {descripcion: comentario, notificadoVa:notificar}
            this.api.PostMethod(url , payload, {}, 'Ocurrió un error al Insertar el comentario de seguimiento')
                .subscribe(response => {
                    resolve(response)
                    this.getComentariosByEntity(entityUuid)
                })
        })
    }

    
}